// extracted by mini-css-extract-plugin
export default {"blog":"BlogGrid_blog__7iERg","thumb":"BlogGrid_thumb__MsApg","content":"BlogGrid_content__HR0sn","readmoreBtn":"BlogGrid_readmoreBtn__0aBmd"};